/* Grippatch - urun sayfasi: galeri, sekmeler, varyant */

/* Galeri: tek buyuk sahne + kucuk resim seridi + lightbox.
   Sahne yatay `scroll-snap` seridi -> dokunmatikte kaydirma tarayicidan
   gelir; JS yalnizca oklari, kucuk resimleri ve sayaci baglar.
   Buyutme YENI SEKMEDE degil, sayfa ustunde lightbox ile yapilir. */

/* ----------------------------- galeri + lightbox -------------------------- */

function initGallery(root) {
  const track = root.querySelector('[data-gal-track]');
  if (!track) return;

  const slides = Array.from(track.querySelectorAll('[data-gal-slide]'));
  if (!slides.length) return;

  const thumbs = Array.from(root.querySelectorAll('[data-gal-thumb]'));
  const prev = root.querySelector('[data-gal-prev]');
  const next = root.querySelector('[data-gal-next]');
  const now = root.querySelector('[data-gal-now]');
  const lbx = document.querySelector('[data-lbx]');

  let index = 0;

  const setIndex = (i) => {
    index = Math.max(0, Math.min(slides.length - 1, i));
    thumbs.forEach((t, n) => t.classList.toggle('is-on', n === index));
    if (now) now.textContent = String(index + 1);
    // Uc slaytlarda ilgili ok soner (yerinde kalir, sahne genisligi oynamasin)
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;
    // Secili kucuk resim seridin disinda kalmasin
    const th = thumbs[index];
    if (th && th.parentElement) {
      const kap = th.parentElement;
      const sol = th.offsetLeft - kap.offsetLeft;
      if (sol < kap.scrollLeft || sol + th.offsetWidth > kap.scrollLeft + kap.clientWidth) {
        kap.scrollTo({ left: sol - 12, behavior: 'smooth' });
      }
    }
  };

  const goto = (i) => {
    const hedef = slides[Math.max(0, Math.min(slides.length - 1, i))];
    if (!hedef) return;
    // Serinin KENDISI kaydirilir; window.scrollTo DEGIL (sayfa ziplamasin)
    track.scrollTo({ left: hedef.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    setIndex(i);
  };

  // Parmakla kaydirmada aktif slaytI seriden geri oku
  let bekle;
  track.addEventListener('scroll', () => {
    clearTimeout(bekle);
    bekle = setTimeout(() => {
      const genislik = slides[0].offsetWidth || 1;
      setIndex(Math.round(track.scrollLeft / genislik));
    }, 90);
  }, { passive: true });

  if (prev) prev.addEventListener('click', () => goto(index - 1));
  if (next) next.addEventListener('click', () => goto(index + 1));

  thumbs.forEach((t, n) => {
    t.addEventListener('click', (e) => {
      // <a href="#..."> capasi JS yokken calissin diye duruyor; JS varken
      // adres cubugunu kirletmesin ve sayfa ziplamasin.
      e.preventDefault();
      goto(n);
    });
  });

  // Sahneye tiklayinca lightbox
  const gorseller = slides.map((s) => ({
    src: s.dataset.full || (s.querySelector('img') || {}).src || '',
    alt: s.dataset.alt || '',
    hazir: '',
  }));
  // Galeride o an INMIS surum (lightbox'ta aninda gostermek icin)
  const hazirla = (n) => {
    const im = slides[n] && slides[n].querySelector('img');
    gorseller[n].hazir = im && im.complete && im.naturalWidth ? (im.currentSrc || im.src) : '';
  };

  slides.forEach((s, n) => {
    s.addEventListener('click', () => { hazirla(n); openLightbox(gorseller, n, s); });
  });

  /* Iki parmakla buyutme: SAYFA degil urun gorseli buyur.
     Slaytlarda `touch-action: pan-x pan-y` var (tarayici sayfayi
     yakinlastirmaz). Iki parmak degdigi anda lightbox acilir ve AYNI
     hareket oradaki buyutmeyi surdurur - dokunma olaylari parmagin ilk
     degdigi ogeye bagli kaldigi icin lightbox ustte olsa da buraya gelir.
     Tek parmak hic etkilenmez: yatay serit + dikey sayfa kaydirma aynen. */
  let devir = null;
  track.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 2 || devir) return;
    const slayt = e.target.closest && e.target.closest('[data-gal-slide]');
    if (!slayt) return;
    e.preventDefault();
    const n = slides.indexOf(slayt);
    hazirla(n);
    openLightbox(gorseller, n, slayt);
    devir = lbxDurum && lbxDurum.zoom;
    if (devir) devir.pinchBasla(e.touches[0], e.touches[1]);
  }, { passive: false });
  track.addEventListener('touchmove', (e) => {
    if (!devir) return;
    e.preventDefault();
    if (e.touches.length >= 2) devir.pinchGuncelle(e.touches[0], e.touches[1]);
  }, { passive: false });
  const devirBitir = (e) => {
    if (!devir || e.touches.length >= 2) return;
    devir.pinchBitir();
    devir = null;
  };
  track.addEventListener('touchend', devirBitir);
  track.addEventListener('touchcancel', devirBitir);
  // iOS Safari: galeride iki parmak sayfayi yakinlastirmasin
  ['gesturestart', 'gesturechange'].forEach((tip) => track.addEventListener(tip, (e) => e.preventDefault()));

  setIndex(0);

  // Klavye: galeri odaktayken sag/sol ok
  root.addEventListener('keydown', (e) => {
    if (lbx && !lbx.hidden) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); goto(index + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); goto(index - 1); }
  });
}

let lbxDurum = null;

/* --------------------------- lightbox: buyutme ----------------------------
   Iki parmak (pinch) GORSELI buyutur, sayfayi degil: `.lbx` uzerinde
   `touch-action: none` var, hareketin tamamini burada yonetiyoruz.
     - iki parmak: buyut/kucult, parmak ortasi sabit kalir
     - tek parmak: buyukken gezdir; normal boyda saga/sola = onceki/sonraki,
       asagi cekme = kapat
     - cift dokunma / fare tiklamasi: 1x <-> 2.5x (dokunulan noktaya)
     - fare tekerlegi + trackpad pinch (ctrl+wheel): imlecin oldugu yere
     - klavye: + / - / 0
   Hesap: `transform: translate(tx,ty) scale(s)`, koken sol ust (CSS).
   Gorselin DONUSUMSUZ kutusu offsetLeft/Top ile okunur - transform
   offset degerlerini etkilemedigi icin gecis animasyonu ortasinda da dogru.
   ------------------------------------------------------------------------ */

const ZOOM_MAX = 4;
const ZOOM_CIFT = 2.5;

function zoomKur(lbx, img) {
  let s = 1;
  let tx = 0;
  let ty = 0;
  let kutu = null; // { ox, oy, w, h } - donusumsuz gorsel kutusu (ekran koord.)

  const olc = () => {
    const fig = img.offsetParent;
    if (!fig || !img.offsetWidth) { kutu = null; return false; }
    const r = fig.getBoundingClientRect();
    kutu = { ox: r.left + img.offsetLeft, oy: r.top + img.offsetTop, w: img.offsetWidth, h: img.offsetHeight };
    return true;
  };

  const uygula = (animasyon) => {
    img.classList.toggle('is-hareket', !animasyon);
    img.classList.toggle('is-buyuk', s > 1.01);
    img.style.transform = (s === 1 && tx === 0 && ty === 0) ? '' : `translate(${tx}px, ${ty}px) scale(${s})`;
  };

  // Gorsel kenari ekran kenarinin icine kacmasin; ekrandan kucukse ortala
  const sinirla = () => {
    if (!kutu) return;
    const W = lbx.clientWidth;
    const H = lbx.clientHeight;
    const eksen = (t, o, boy, alan) => {
      const b = boy * s;
      if (b <= alan) return (alan - b) / 2 - o;
      return Math.min(-o, Math.max(alan - o - b, t));
    };
    tx = eksen(tx, kutu.ox, kutu.w, W);
    ty = eksen(ty, kutu.oy, kutu.h, H);
  };

  // Ekrandaki (px,py) noktasi gorselin ayni yerinde kalacak sekilde olcekle
  const olcekle = (yeni, px, py, alt = 1, ust = ZOOM_MAX) => {
    if (!kutu && !olc()) return;
    const lx = (px - kutu.ox - tx) / s;
    const ly = (py - kutu.oy - ty) / s;
    s = Math.min(ust, Math.max(alt, yeni));
    tx = px - kutu.ox - lx * s;
    ty = py - kutu.oy - ly * s;
  };

  const sifirla = (animasyon = false) => {
    s = 1; tx = 0; ty = 0;
    uygula(animasyon);
  };

  const yerlestir = () => {
    if (s <= 1.01) { sifirla(true); return; }
    sinirla();
    uygula(true);
  };

  const degistir = (px, py) => {
    if (!olc()) return;
    if (s > 1.01) { sifirla(true); return; }
    olcekle(ZOOM_CIFT, px, py);
    sinirla();
    uygula(true);
  };

  /* --- iki parmak: hem lightbox'in kendi dokunuslari hem galeriden
         devralinan hareket ayni uc fonksiyonu kullanir --- */
  let pinch = null;
  const orta = (a, b) => ({ x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 });
  const mesafe = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1;

  const pinchBasla = (a, b) => {
    if (!olc()) { pinch = null; return; }
    const m = orta(a, b);
    pinch = { d0: mesafe(a, b), s0: s, lx: (m.x - kutu.ox - tx) / s, ly: (m.y - kutu.oy - ty) / s };
  };
  const pinchGuncelle = (a, b) => {
    if (!pinch) { pinchBasla(a, b); return; }
    const m = orta(a, b);
    // Hareket sirasinda sinirlarin biraz disina esneyebilir, birakinca oturur
    s = Math.min(ZOOM_MAX * 1.25, Math.max(0.75, pinch.s0 * (mesafe(a, b) / pinch.d0)));
    tx = m.x - kutu.ox - pinch.lx * s;
    ty = m.y - kutu.oy - pinch.ly * s;
    uygula(false);
  };
  const pinchBitir = () => {
    pinch = null;
    if (s > ZOOM_MAX && kutu) {
      const c = { x: kutu.ox + tx + (kutu.w * s) / 2, y: kutu.oy + ty + (kutu.h * s) / 2 };
      olcekle(ZOOM_MAX, c.x, c.y);
    }
    yerlestir();
  };

  /* --- isaretci olaylari (lightbox'in kendi yuzeyi) --- */
  const isaret = new Map();
  let tek = null;      // tek parmak/fare surukleme baslangici
  let oynadi = false;  // tiklamayi bastirmak icin: surukleme oldu mu
  let sonDokunus = { t: 0, x: 0, y: 0 };
  let sonTur = 'mouse'; // son basilan isaretci: tiklamanin fare mi dokunus mu oldugu

  const dugmeMi = (el) => el.closest && el.closest('.lbx__close, .lbx__nav');

  lbx.addEventListener('pointerdown', (e) => {
    sonTur = e.pointerType;
    if (dugmeMi(e.target)) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    isaret.set(e.pointerId, e);
    oynadi = false;
    if (isaret.size === 2) {
      const [a, b] = Array.from(isaret.values());
      tek = null;
      pinchBasla(a, b);
    } else if (isaret.size === 1) {
      olc();
      tek = { x: e.clientX, y: e.clientY, tx, ty, tur: e.pointerType, gorselde: e.target === img };
      // Fare ile buyuk gorseli surukleme: imlec gorselden ciksa da devam etsin
      if (e.pointerType === 'mouse' && s > 1.01) img.setPointerCapture?.(e.pointerId);
    }
  });

  lbx.addEventListener('pointermove', (e) => {
    if (!isaret.has(e.pointerId)) return;
    isaret.set(e.pointerId, e);
    if (isaret.size >= 2) {
      const [a, b] = Array.from(isaret.values());
      oynadi = true;
      pinchGuncelle(a, b);
      return;
    }
    if (!tek) return;
    const dx = e.clientX - tek.x;
    const dy = e.clientY - tek.y;
    if (Math.abs(dx) + Math.abs(dy) > 6) oynadi = true;
    if (s > 1.01) {
      tx = tek.tx + dx;
      ty = tek.ty + dy;
      sinirla();
      uygula(false);
    } else if (tek.tur !== 'mouse' && oynadi) {
      // Normal boyda: gorsel parmagi izler (geri birakinca oturur)
      img.classList.add('is-hareket');
      img.style.transform = Math.abs(dx) > Math.abs(dy)
        ? `translate(${dx}px, 0)`
        : `translate(0, ${Math.max(0, dy)}px)`;
    }
  });

  const birak = (e) => {
    if (!isaret.has(e.pointerId)) return;
    isaret.delete(e.pointerId);

    if (pinch) {
      if (isaret.size === 1) {
        // Bir parmak kalkti: kalan parmakla gezdirmeye devam
        const kalan = Array.from(isaret.values())[0];
        pinchBitir();
        olc();
        tek = { x: kalan.clientX, y: kalan.clientY, tx, ty, tur: kalan.pointerType, gorselde: false };
        return;
      }
      pinchBitir();
      tek = null;
      return;
    }

    if (!tek || isaret.size) return;
    const dx = e.clientX - tek.x;
    const dy = e.clientY - tek.y;
    const t = tek;
    tek = null;

    // Cift dokunma (buyukte de, normalde de): buyut <-> sifirla
    if (t.tur !== 'mouse' && e.type === 'pointerup' && !oynadi && t.gorselde) {
      const simdi = Date.now();
      if (simdi - sonDokunus.t < 320 && Math.hypot(e.clientX - sonDokunus.x, e.clientY - sonDokunus.y) < 40) {
        sonDokunus = { t: 0, x: 0, y: 0 };
        degistir(e.clientX, e.clientY);
        return;
      }
      sonDokunus = { t: simdi, x: e.clientX, y: e.clientY };
    }

    if (s > 1.01) { yerlestir(); return; }

    if (t.tur !== 'mouse' && e.type === 'pointerup') {
      // Normal boyda kaydirma hareketleri
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        sifirla(false);
        if (lbxDurum) lbxDurum.git(dx < 0 ? 1 : -1);
        return;
      }
      if (dy > 110 && dy > Math.abs(dx) * 1.2) {
        sifirla(false);
        if (lbxDurum) lbxDurum.kapat();
        return;
      }
      if (oynadi) sifirla(true);
    }
  };
  lbx.addEventListener('pointerup', birak);
  lbx.addEventListener('pointercancel', birak);

  // Fare tiklamasi gorselde: buyut/kucult. Surukleme sonrasi tiklama
  // (or. arka plana denk gelen birakma) lightbox'i KAPATMASIN.
  lbx.addEventListener('click', (e) => {
    if (oynadi) {
      oynadi = false;
      if (!dugmeMi(e.target)) { e.preventDefault(); e.stopPropagation(); }
      return;
    }
    // Dokunmatikte buyutme cift dokunmayla; tek dokunus bir sey yapmaz
    if (e.target === img && sonTur !== 'touch') degistir(e.clientX, e.clientY);
  }, true);

  lbx.addEventListener('wheel', (e) => {
    e.preventDefault();
    if (!olc()) return;
    // ctrl+wheel = trackpad pinch: daha hassas
    const k = Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0022));
    olcekle(s * k, e.clientX, e.clientY);
    if (s <= 1.001) { sifirla(false); return; }
    sinirla();
    uygula(false);
  }, { passive: false });

  // iOS Safari kendi sayfa yakinlastirmasini bu olaylarla yapar
  ['gesturestart', 'gesturechange'].forEach((tip) => lbx.addEventListener(tip, (e) => e.preventDefault()));

  window.addEventListener('resize', () => { if (!lbx.hidden) sifirla(false); });

  const klavye = (anahtar) => {
    if (!olc()) return false;
    const cx = kutu.ox + tx + (kutu.w * s) / 2;
    const cy = kutu.oy + ty + (kutu.h * s) / 2;
    if (anahtar === '+' || anahtar === '=') olcekle(s * 1.5, cx, cy);
    else if (anahtar === '-') olcekle(s / 1.5, cx, cy);
    else if (anahtar === '0') { sifirla(true); return true; }
    else return false;
    yerlestir();
    return true;
  };

  return {
    sifirla,
    klavye,
    pinchBasla,
    pinchGuncelle,
    pinchBitir,
    buyukMu: () => s > 1.01,
  };
}

let ipucuGosterildi = false;

function openLightbox(gorseller, baslangic, acan) {
  const lbx = document.querySelector('[data-lbx]');
  if (!lbx || !gorseller.length) return;

  const img = lbx.querySelector('[data-lbx-img]');
  const now = lbx.querySelector('[data-lbx-now]');
  const total = lbx.querySelector('[data-lbx-total]');
  const prev = lbx.querySelector('[data-lbx-prev]');
  const next = lbx.querySelector('[data-lbx-next]');
  const ipucu = lbx.querySelector('[data-lbx-ipucu]');

  if (!lbx.zoom) lbx.zoom = zoomKur(lbx, img);
  const zoom = lbx.zoom;

  let i = baslangic;

  const goster = () => {
    const g = gorseller[i];
    zoom.sifirla(false);
    /* Galeride zaten INMIS gorsel once konur: kutu boyutu aninda belli
       olur (galeriden devralinan iki parmak hareketi hemen calisir),
       buyuk surum yuklenince sessizce yerine gecer. */
    if (g.hazir && g.hazir !== g.src) {
      img.src = g.hazir;
      const tam = new Image();
      tam.onload = () => { if (gorseller[i] === g) img.src = g.src; };
      tam.src = g.src;
    } else {
      img.src = g.src;
    }
    img.alt = g.alt;
    if (now) now.textContent = String(i + 1);
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === gorseller.length - 1;
    // Komsu gorseli onceden indir - ok'a basinca beklenmesin
    [i - 1, i + 1].forEach((n) => {
      if (gorseller[n]) { const p = new Image(); p.src = gorseller[n].src; }
    });
  };

  const git = (adim) => {
    const yeni = i + adim;
    if (yeni < 0 || yeni >= gorseller.length) return;
    i = yeni;
    goster();
  };

  const tus = (e) => {
    if (e.key === 'Escape') { e.preventDefault(); kapat(); }
    else if (e.key === 'ArrowRight' && !zoom.buyukMu()) { e.preventDefault(); git(1); }
    else if (e.key === 'ArrowLeft' && !zoom.buyukMu()) { e.preventDefault(); git(-1); }
    else if (zoom.klavye(e.key)) { e.preventDefault(); }
    else if (e.key === 'Tab') {
      // Odak lightbox icinde kalsin
      const odaklanabilir = Array.from(lbx.querySelectorAll('button:not([disabled])'))
        .filter((el) => el.offsetParent !== null);
      if (!odaklanabilir.length) return;
      const ilk = odaklanabilir[0];
      const son = odaklanabilir[odaklanabilir.length - 1];
      if (e.shiftKey && document.activeElement === ilk) { e.preventDefault(); son.focus(); }
      else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); ilk.focus(); }
    }
  };

  function kapat() {
    zoom.sifirla(false);
    lbx.hidden = true;
    document.body.classList.remove('lbx-open');
    document.documentElement.classList.remove('lbx-open');
    document.removeEventListener('keydown', tus);
    lbxDurum = null;
    // Odak, lightbox'i acan gorsele geri doner. preventScroll: odak
    // sayfayi galeriye geri ZIPLATMASIN (kullanici asagi kaydirmis olabilir)
    if (acan && typeof acan.focus === 'function') acan.focus({ preventScroll: true });
  }

  if (total) total.textContent = String(gorseller.length);
  // Tek gorselde oklar gizlenir; sonraki acilis cok gorselliyse geri gelir
  const tekGorsel = gorseller.length < 2;
  if (prev) prev.hidden = tekGorsel;
  if (next) next.hidden = tekGorsel;

  if (!lbx.dataset.ready) {
    lbx.dataset.ready = '1';
    lbx.querySelectorAll('[data-lbx-close]').forEach((b) => b.addEventListener('click', () => lbxDurum && lbxDurum.kapat()));
    if (prev) prev.addEventListener('click', () => lbxDurum && lbxDurum.git(-1));
    if (next) next.addEventListener('click', () => lbxDurum && lbxDurum.git(1));
  }

  lbxDurum = { git, kapat, zoom };
  goster();
  lbx.hidden = false;
  document.body.classList.add('lbx-open');
  document.documentElement.classList.add('lbx-open');
  document.addEventListener('keydown', tus);
  const kapatBtn = lbx.querySelector('.lbx__close');
  if (kapatBtn) kapatBtn.focus({ preventScroll: true });

  // Buyutme ipucu: sayfa basina bir kez, 2,5 sn
  if (ipucu && !ipucuGosterildi) {
    ipucuGosterildi = true;
    const dokunmatik = window.matchMedia('(pointer: coarse)').matches;
    ipucu.textContent = dokunmatik ? ipucu.dataset.dokunmatik : ipucu.dataset.fare;
    if (ipucu.textContent) {
      ipucu.classList.remove('is-gizli');
      setTimeout(() => ipucu.classList.add('is-gizli'), 2500);
    }
  }
}

/* --------------------------------- paylas --------------------------------
   Sag ustteki yuvarlak buton menuyu acar/kapatir. Menudeki sosyal
   baglantilar normal <a> - JS olmadan da calisir; JS yalnizca menuyu
   acmak ve "baglantiyi kopyala" icin gerekli. Bu yuzden sarmalayici
   `hidden` basliyor ve burada aciliyor: JS yoksa yarim calisan bir
   arayuz gorunmesin.
   ------------------------------------------------------------------------ */

function initShare() {
  const wrap = document.querySelector('[data-share-wrap]');
  if (!wrap) return;
  // initPDP her `shopify:section:load` olayinda kosuyor; dinleyici birikmesin
  if (wrap.dataset.ready === '1') return;
  wrap.dataset.ready = '1';

  const btn = wrap.querySelector('[data-share-toggle]');
  const menu = wrap.querySelector('[data-share-menu]');
  const kopyala = wrap.querySelector('[data-share]');
  const tip = wrap.querySelector('[data-share-tip]');
  if (!btn || !menu) return;

  wrap.hidden = false;

  const ac = (acik) => {
    menu.hidden = !acik;
    btn.setAttribute('aria-expanded', acik ? 'true' : 'false');
  };

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    ac(menu.hidden);
  });

  // Disari tiklayinca / ESC ile kapan
  document.addEventListener('click', (e) => {
    if (!menu.hidden && !wrap.contains(e.target)) ac(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menu.hidden) {
      ac(false);
      btn.focus();
    }
  });

  if (!kopyala) return;

  let zaman;
  kopyala.addEventListener('click', async () => {
    const url = kopyala.dataset.url || window.location.href;
    const baslik = kopyala.dataset.title || document.title;

    // Mobilde cihazin kendi paylasim sayfasi varsa once o
    if (navigator.share) {
      try {
        await navigator.share({ title: baslik, url });
        ac(false);
        return;
      } catch (e) {
        // Kullanici vazgectiyse sessizce cik; baska hatada panoya dus
        if (e && e.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      // Guvenli olmayan baglamda clipboard yok - eski yontem
      const alan = document.createElement('textarea');
      alan.value = url;
      alan.setAttribute('readonly', '');
      alan.style.position = 'fixed';
      alan.style.opacity = '0';
      document.body.appendChild(alan);
      alan.select();
      try { document.execCommand('copy'); } catch (err) { /* yapacak bir sey yok */ }
      document.body.removeChild(alan);
    }

    kopyala.classList.add('is-copied');
    if (tip) tip.hidden = false;
    clearTimeout(zaman);
    zaman = setTimeout(() => {
      kopyala.classList.remove('is-copied');
      if (tip) tip.hidden = true;
    }, 2000);
  });
}

function initTabs(root) {
  const tabs = root.querySelectorAll('[data-tab]');
  const panels = root.querySelectorAll('[data-panel]');
  if (!tabs.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const key = tab.dataset.tab;
      tabs.forEach((t) => t.classList.toggle('is-on', t === tab));
      panels.forEach((p) => {
        const on = p.dataset.panel === key;
        p.classList.toggle('is-on', on);
        p.hidden = !on;
      });
    });
  });
}

function initVariants() {
  const dataEl = document.querySelector('[data-variants]');
  const form = document.querySelector('[data-variant-id]');
  if (!dataEl || !form) return;

  let variants = [];
  try {
    variants = JSON.parse(dataEl.textContent) || [];
  } catch (e) {
    return;
  }

  const selects = document.querySelectorAll('[data-opt]');
  if (!selects.length) return;

  const priceEl = document.querySelector('[data-price]');
  const addBtn = document.querySelector('.pdp__add');

  const money = (cents) => {
    const val = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${val} ${window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : ''}`.trim();
  };

  const sync = () => {
    const chosen = Array.from(selects).map((s) => s.value);
    const match = variants.find((v) => chosen.every((val, idx) => v.options[idx] === val));

    if (!match) {
      if (addBtn) addBtn.disabled = true;
      return;
    }

    form.value = match.id;

    if (priceEl) {
      let html = money(match.price);
      if (match.compare_at_price && match.compare_at_price > match.price) {
        html += `<del>${money(match.compare_at_price)}</del>`;
      }
      priceEl.innerHTML = html;
      priceEl.classList.toggle('price--sale', Boolean(match.compare_at_price && match.compare_at_price > match.price));
    }

    if (addBtn) addBtn.disabled = !match.available;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  };

  selects.forEach((s) => s.addEventListener('change', sync));
}

/* ------------------------------ benzer urunler ---------------------------- */

/*
 * Mobilde yatay serit; bu islev YALNIZCA sayfa noktalarini ciziyor.
 * Kaydirmanin kendisi CSS'ten (`overflow-x` + `scroll-snap`) geliyor, yani
 * JS calismasa da serit parmakla kayar - sadece noktalar cikmaz.
 *
 * Nokta sayisi SABIT VARSAYILMIYOR: kart genisligi ekrana gore degistigi
 * icin "kac sayfa var" olculen genislikten hesaplaniyor. Masaustunde serit
 * kaydirilamaz (izgara), scrollWidth == clientWidth cikar, tek sayfa olur ve
 * noktalar hic basilmaz.
 */
function initBenzer(root) {
  const liste = root.querySelector('[data-benzer-liste]');
  const noktaKap = root.querySelector('[data-benzer-noktalar]');
  if (!liste || !noktaKap) return;

  const sayfaSayisi = () =>
    liste.clientWidth ? Math.max(1, Math.round(liste.scrollWidth / liste.clientWidth)) : 1;
  const aktifSayfa = () =>
    liste.clientWidth ? Math.round(liste.scrollLeft / liste.clientWidth) : 0;

  const guncelle = () => {
    const a = aktifSayfa();
    Array.from(noktaKap.children).forEach((b, i) => b.classList.toggle('is-on', i === a));
  };

  const ciz = () => {
    const n = sayfaSayisi();
    noktaKap.innerHTML = '';
    if (n < 2) return; // tek sayfa -> nokta gostermenin anlami yok
    for (let i = 0; i < n; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'benzer__nokta';
      b.setAttribute('aria-label', String(i + 1));
      b.addEventListener('click', () => {
        liste.scrollTo({ left: i * liste.clientWidth, behavior: 'smooth' });
      });
      noktaKap.appendChild(b);
    }
    guncelle();
  };

  let bekle;
  liste.addEventListener(
    'scroll',
    () => {
      clearTimeout(bekle);
      bekle = setTimeout(guncelle, 80);
    },
    { passive: true }
  );

  window.addEventListener('resize', ciz);
  ciz();
}

/* ---------------------------- gelince haber ver --------------------------- */

/*
 * Tukenen urunlerde e-posta toplama.
 *
 * ⚠️ SHOPIFY'DA YERLESIK BIR "STOK GELINCE POSTA AT" OZELLIGI YOK
 * (dogrulandi 2026-08-24). Bu yuzden kayit IKI yoldan birine gidiyor:
 *
 *   1. Panelde "Stok bildirim ucu" doluysa -> oraya JSON POST.
 *      Otomatik gonderimi o arka uc yapar (Joykek n8n akisi).
 *   2. Bos ise -> Shopify'in KENDI iletisim formu (`/contact`).
 *      Kayit magazanin bildirim e-postasina duser; otomatik degil ama
 *      buton OLU kalmaz ve talep kaybolmaz.
 *
 * `/contact` ucu 302 ile yonlendirme dondugu icin `redirect: 'manual'`
 * kullanilmiyor - `fetch` yonlendirmeyi kendisi izliyor ve 200 doner.
 * Basarisizligi HTTP durumundan anlıyoruz, govdeyi ayristirmiyoruz.
 */
function initStokBildirim(kok) {
  const ac = kok.querySelector('[data-stokbil-ac]');
  const kutu = kok.querySelector('.stokbil__kutu');
  const form = kok.querySelector('[data-stokbil-form]');
  const sonuc = kok.querySelector('[data-stokbil-sonuc]');
  if (!ac || !kutu || !form) return;

  const s = kok.dataset;
  /* Metinler `locales/*.json`den geliyor; Liquid onlari data-niteligi olarak
     basiyor (bkz sections/main-product.liquid). JS'te sabit Turkce yazi
     tutulmuyor - yedek degerler yalniz nitelik hic basilmadiysa devreye girer. */
  const metin = {
    basarili: s.mBasarili,
    hata: s.mHata,
    epostaHatali: s.mEpostaHatali,
    onayGerekli: s.mOnayGerekli,
    gonderiliyor: s.mGonderiliyor,
    kapali: s.mKapali,
  };

  ac.addEventListener('click', () => {
    const acik = !kutu.hidden;
    kutu.hidden = acik;
    ac.setAttribute('aria-expanded', String(!acik));
    if (!acik) {
      const alan = form.querySelector('input[type="email"]');
      if (alan) alan.focus();
    }
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const eposta = form.querySelector('input[type="email"]');
    const onay = form.querySelector('input[name="kvkk"]');
    const gonder = form.querySelector('button[type="submit"]');

    sonuc.className = 'stokbil__sonuc';

    /* Tarayici dogrulamasi `novalidate` ile kapali: hata metnini kendimiz
       Turkce veriyoruz, tarayicinin kendi balonu magaza diliyle uyusmuyor. */
    if (!eposta.value || !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(eposta.value.trim())) {
      sonuc.textContent = metin.epostaHatali || 'Geçerli bir e-posta adresi gir.';
      sonuc.classList.add('is-hata');
      eposta.focus();
      return;
    }
    if (onay && !onay.checked) {
      sonuc.textContent = metin.onayGerekli || 'Devam etmek için onay kutusunu işaretle.';
      sonuc.classList.add('is-hata');
      return;
    }

    const eskiEtiket = gonder.textContent;
    gonder.disabled = true;
    gonder.textContent = metin.gonderiliyor || '...';

    const veri = {
      email: eposta.value.trim(),
      product: s.urun || '',
      handle: s.handle || '',
      variant_id: kok.closest('.pdp__info')?.querySelector('[data-variant-id]')?.value || s.varyant || '',
      url: window.location.href,
      locale: document.documentElement.lang || 'tr',
    };

    let durum = 0;
    try {
      let ok = false;
      if (s.uc) {
        const r = await fetch(s.uc, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(veri),
        });
        durum = r.status;
        ok = r.ok;
      } else {
        /* Shopify iletisim formu: alanlar `contact[...]` adiyla bekleniyor. */
        const fd = new FormData();
        fd.append('form_type', 'contact');
        fd.append('utf8', '✓');
        fd.append('contact[email]', veri.email);
        fd.append('contact[body]',
          'STOK BILDIRIM TALEBI\n' +
          'Ürün: ' + veri.product + '\n' +
          'Handle: ' + veri.handle + '\n' +
          'Varyant: ' + veri.variant_id + '\n' +
          'Sayfa: ' + veri.url);
        const r = await fetch('/contact', { method: 'POST', body: fd });
        durum = r.status;
        ok = r.ok;
      }

      if (!ok) throw new Error('gonderilemedi');
      form.innerHTML = '';
      sonuc.className = 'stokbil__sonuc is-basarili';
      sonuc.textContent = metin.basarili || 'Kaydını aldık.';
      form.appendChild(sonuc);
      ac.disabled = true;
    } catch (err) {
      /* 403 = form gonderimi KAPALI.
         Magaza sifre korumaliyken Shopify TUM vitrin form POST'larini
         reddediyor - magazanin kendi iletisim ve bulten formlari da 403
         doner (olculdu 2026-08-24). Yani bu bir kod hatasi degil, kapi.
         Ayni durum canlida bir kural/koruma devreye girerse de olusabilir;
         iki halde de ziyaretciyi bos birakmamak icin WhatsApp yedegi
         gosteriliyor - talep kaybolmasin. */
      sonuc.textContent = (durum === 403 && metin.kapali)
        ? metin.kapali
        : (metin.hata || 'Kayıt alınamadı. Lütfen biraz sonra tekrar dene.');
      sonuc.classList.add('is-hata');

      if (s.wa && !sonuc.nextElementSibling) {
        const bag = document.createElement('a');
        bag.className = 'btn btn--orange btn--full stokbil__wa';
        bag.href = s.wa;
        bag.target = '_blank';
        bag.rel = 'noopener';
        bag.textContent = 'WhatsApp\'tan yazın';
        sonuc.insertAdjacentElement('afterend', bag);
      }

      gonder.disabled = false;
      gonder.textContent = eskiEtiket;
    }
  });
}

function initPDP() {
  document.querySelectorAll('[data-tabs]').forEach((el) => {
    if (el.dataset.ready === '1') return;
    el.dataset.ready = '1';
    initTabs(el);
  });

  document.querySelectorAll('[data-gal]').forEach((el) => {
    if (el.dataset.ready === '1') return;
    el.dataset.ready = '1';
    initGallery(el);
  });

  document.querySelectorAll('[data-stok-bildirim]').forEach((el) => {
    if (el.dataset.ready === '1') return;
    el.dataset.ready = '1';
    initStokBildirim(el);
  });

  document.querySelectorAll('[data-benzer]').forEach((el) => {
    if (el.dataset.ready === '1') return;
    el.dataset.ready = '1';
    initBenzer(el);
  });

  initShare();
  initVariants();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPDP);
} else {
  initPDP();
}

document.addEventListener('shopify:section:load', initPDP);
